import axios from 'axios';

export default {
  loadLocales(language, identifier) {
    return axios.get(`https://storage.googleapis.com/hyll-web-app-translations/${identifier}/${language}.json`);
  },
};
